import { useMutation } from '@apollo/client';
import { gql } from '__generated__/gql';
import { FC } from 'react';

import ErrorMessage from 'components/ErrorMessage';

import ConfirmButton from 'primitives/ConfirmButton';

const SUBMIT_UNIT_TRANSFER_REQUEST_MUTATION = gql(`
  mutation SubmitUnitTransferRequest($id: ID!) {
    submitUnitTransferRequest(id: $id) {
      id
      status
    }
  }
`);

// The wizard creates the request as a DRAFT before its final step, so anyone who navigates away at
// that point lands here with a request that exists but was never submitted. Without this the only
// action on the page is Withdraw — and because DRAFT is not a terminal status, that stranded draft
// also blocks the investor from starting a new request (BUS_060). Submitting from the tracker is
// the recovery path.
const SubmitUnitTransferRequestButton: FC<{ requestId: string; onSubmitted: () => void }> = ({
  requestId,
  onSubmitted,
}) => {
  const [submitRequest, { loading, error }] = useMutation(SUBMIT_UNIT_TRANSFER_REQUEST_MUTATION);

  return (
    <div>
      <ConfirmButton
        title="Submit this transfer request?"
        description="We'll notify the transferee so they can review and accept it. You won't be able to change the details after this."
        confirmButtonLabel="Submit request"
        loading={loading}
        onConfirm={() =>
          submitRequest({ variables: { id: requestId } }).then(result => {
            if (result.data?.submitUnitTransferRequest) onSubmitted();
          })
        }
      >
        Submit request
      </ConfirmButton>
      {error ? <ErrorMessage error={error} type="alert" /> : null}
    </div>
  );
};

export default SubmitUnitTransferRequestButton;
